import {
  ErrorComponent,
  type ErrorComponentProps,
} from '@tanstack/react-router';
import { isQuietStaleChunk } from '@/lib/stale-chunk-error';
import { StaleChunkRecovery } from './StaleChunkRecovery';

/**
 * Router-level error screen. A stale chunk (e.g. a CSS preload TanStack does
 * not auto-reload for) gets the refresh prompt; anything else keeps
 * TanStack's default.
 */
export function RouteErrorComponent(props: ErrorComponentProps) {
  if (isQuietStaleChunk(props.error)) {
    return <StaleChunkRecovery />;
  }
  return <ErrorComponent {...props} />;
}
